<comment-tab-header
  [feedbackSession]="feedbackSession"
  (rerunAiFeedback)="rerunAiFeedback()"
  [rerunningAiFeedback]="rerunningAiFeedback"
></comment-tab-header>

<div [ngClass]="{'no-comments': zeroState !== null}" class="comment-panel-content"
  role="tabpanel" [id]="'feedback-main-header-tabpanel-comment'"
  [attr.aria-labelledby]="'feedback-main-header-tab-comment'">
  <comment-panel-banners
    (addAiAssistant)="addAiAssistant()">
  </comment-panel-banners>

  @if (zeroState === 'add-ai-markers-comment') {
    <ngx-zero-state class="add-ai-markers-comment-zero-state">
      <p zero-state-title [translate]="'feedback-session_comment-zero-state_add-comments_title'"></p>
      <p zero-state-subtext [translate]="'feedback-session_comment-zero-state_add-ai-markers_description'"></p>
      <div zero-state-body>
        <button (click)="addAiAssistant()" class="btn primary-btn"
          [translate]="'feedback-session_comment-zero-state_add-ai-markers_button'">
        </button>
      </div>
      <div zero-state-graphic-bottom>
        <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
      </div>
    </ngx-zero-state>
  }

  @if (zeroState === 'add-comments') {
    <ngx-zero-state class="add-comment-zero-state">
      <p zero-state-title [translate]="'feedback-session_comment-zero-state_add-comments_title'"></p>
      <p zero-state-subtext [innerHTML]="'feedback-session_comment-zero-state_add-comments_description' | translate"></p>
      <div zero-state-graphic-bottom>
        <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
      </div>
    </ngx-zero-state>
  }

  @if (zeroState === 'no-feedback-shown') {
    <ngx-zero-state class="no-feedback-shown-zero-state">
      <p zero-state-title [translate]="'feedback-session_no-feedback-shown-zero-state-title'" tabindex="0"></p>
      <p zero-state-subtext [translate]="'feedback-session_no-feedback-shown-zero-state-description'" tabindex="0">
      </p>
      <div zero-state-graphic-bottom>
        <img src="https://staticassets.goreact.com/Sparkles.svg" alt="No Results">
      </div>
    </ngx-zero-state>
  }

  <comment-viewer
    [ngClass]="{'hide-feedback-tree': zeroState !== null}"
    [playerSync]="playerSync"
    [viewFrom]="viewFrom"
    [tags]="tags"
    (addAiAssistant)="addAiAssistant()"
    (onEdit)="toggleIsEdittingCommentState($event)">
  </comment-viewer>
</div>